import * as React from 'react'
import { PopupType } from '../sdk/utils/types'

export const PopupContext = React.createContext<{ popups: Array<PopupType>, addPopup: (popup: PopupType) => void }>(undefined as any)
export const PopupContextProvider = PopupContext.Provider
export const PopupContextConsumer = PopupContext.Consumer